import React from "react";
import "./MapProviderToggle.css";

const MapProviderToggle = ({ mapProvider, setMapProvider }) => {
  //this bit of code is super helpful because it prevents the mouse from going throug the first layer
  const handleMouseDown = (event) => {
    event.stopPropagation();
  };

  const toggleMapProvider = () => {
    setMapProvider(mapProvider === "osm" ? "stamenTerrain" : "osm");
  };

  return (
    <div className="map-provider-toggle" onMouseDown={handleMouseDown}>
      <button onClick={toggleMapProvider}>Toggle Map Type</button>
    </div>
  );
};

export default MapProviderToggle;
